import { render, staticRenderFns } from "./Judge.vue?vue&type=template&id=5dcba2a8&"
import script from "./Judge.vue?vue&type=script&lang=js&"
export * from "./Judge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dcba2a8')) {
      api.createRecord('5dcba2a8', component.options)
    } else {
      api.reload('5dcba2a8', component.options)
    }
    module.hot.accept("./Judge.vue?vue&type=template&id=5dcba2a8&", function () {
      api.rerender('5dcba2a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/QuestionItem/Judge.vue"
export default component.exports